import supabase from '../supabase/supabase';

const COMPLETIONS_TABLE = 'hms_academy_completions_1715727000000';
const COMPLETION_RPC = 'hms_academy_complete_enrollment_1715727000000';
const COMPLETION_FIELDS = [
  'id',
  'enrollment_id',
  'completed_at',
  'completion_method',
  'completed_by',
  'created_at'
].join(',');

export async function getEnrollmentCompletion(enrollmentId) {
  const { data, error } = await supabase
    .from(COMPLETIONS_TABLE)
    .select(COMPLETION_FIELDS)
    .eq('enrollment_id', enrollmentId)
    .maybeSingle();

  if (error) throw error;
  return data || null;
}

export async function completeEnrollment(enrollmentId) {
  const { data, error } = await supabase.rpc(COMPLETION_RPC, {
    target_enrollment_id: enrollmentId,
    requested_completion_method: 'system'
  });

  if (error) throw error;
  return data;
}